<template>
  <a-modal
    title="智能识别"
    :visible="viz"
    :confirm-loading="confirmLoading"
    @ok="getAddrInfo"
    @cancel="viz = false"
  >
    <div> <a-textarea
      v-model="addrInfo"
      placeholder="例如：张三，13800138000，广东省深圳市福田区保税区金花路29号华宝一号大厦A601"
      :auto-size="{ minRows: 3, maxRows: 5 }"
    /></div>
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addrInfo: '',
      viz: this.visible,
      confirmLoading: false
    }
  },
  watch: {
    visible(n) {
      this.viz = this.visible
    },
    viz(n) {
      this.$emit('update:visible', n)
    }
  },
  methods: {
    async getAddrInfo() {
      if (!this.addrInfo) {
        this.$message.warning('请输入内容')
        return
      }
      const res = await this.$http(this.$api.addressRecognizeAddress, {
        inputContent: this.addrInfo
      })
      if (res) {
        this.viz = false
        this.$emit('success', res)
      }
    }
  }
}
</script>
